export default "__VITE_ASSET__DVXH2seA__"